import { createSlice } from '@reduxjs/toolkit';              

const initialState = {
    getListLoading: false,
    truckListMasterData: [],
    truckList: [],
    autoFetchPolist: false,
    // totalPages: 10,
    // currentPage: 1
    arrangeOrder: 'asc',
    arrangeKey: 'appointment_time',
    useCarrier: 'vendor',
    scheduledList: [],
    unscheduledList: [],
    isSubscriptionUpdate: false,
    subscriptionTruckData: {}
}

export const getTruckReducerSlice = createSlice({
    name: 'getTruckReducer',
    initialState,
    reducers: {
        initiateGetlist: (state, action) => {
            state.getListLoading = true;
            // state.truckList = action.payload.truckList;
            // state.totalPages = action.payload.totalPages;
            // state.currentPage = action.payload.currentPage;
        },
        updateMainTruckList : (state, action) => {
            
            state.getListLoading = false;
            state.truckList = action.payload.truckList;
            state.truckListMasterData = action.payload.truckList;
        },
        updateScheduledList : (state, action) => {
            state.scheduledList = action.payload;
        },
        updateUnscheduledList : (state, action) => {
            state.unscheduledList = action.payload;
        },
        getListSuccess: (state, action) => {
            state.getListLoading = false;
            state.truckList = action.payload.truckList;
            // state.totalPages = action.payload.totalPages;
            // state.currentPage = action.payload.currentPage;
        },
        getListFailure: (state) => {
            state.getListLoading = false;
            state.truckList = [];
            state.truckListMasterData = [];
            state.autoFetchPolist = false;
        },
        getModifiedListFailure:(state) => {
            state.getListLoading = false;
            state.truckList = [];
        },
        getUpdateListSuccess: (state, action) => {
            state.truckList = action.payload.truckList;
        },
        autoFetchPoListSuccess: (state, action) => {
            state.autoFetchPolist = action.payload;
        },
        updateTruckListSortOrder: (state, action) => {
            state.arrangeOrder = action.payload.order
            state.arrangeKey = action.payload.key
        },
        updateUseCarrierTruckTitleColumn: (state, action) => {
            state.useCarrier = action.payload
        },
        resetAllTruckListData: (state) => {
            state.truckList = [];
            state.truckListMasterData = [];
            state.scheduledList = [];
            state.unscheduledList = [];
        },
        updateTruckFromSubscription: (state, action) => {
            const { type, data, index, load_control_num } = action.payload;
            state.isSubscriptionUpdate = true;
            if (type === 'UPDATE') {
                state.truckListMasterData[index] = data;
                state.truckList[index] = data;
            } else if (type === 'ADD') {
                state.truckListMasterData.push(data);
                state.truckList.push(data);
            } else if (type === 'DELETE') {
                state.truckListMasterData = state.truckListMasterData.filter(
                    (truck) => truck.load_control_num !== load_control_num
                );
                state.truckList = state.truckList.filter(
                    (truck) => truck.load_control_num !== load_control_num
                );
            }
        },
        resetSubscriptionUpdateFlag: (state, action) => {
            state.isSubscriptionUpdate = action.payload;
        },
        setSubscriptionTruckData: (state, action) => {
            state.subscriptionTruckData = action.payload
        }
    }
});

export const { initiateGetlist, getListSuccess, getListFailure, updateMainTruckList, getModifiedListFailure, getUpdateListSuccess, autoFetchPoListSuccess, updateTruckListSortOrder, updateUseCarrierTruckTitleColumn, resetAllTruckListData, updateScheduledList, updateUnscheduledList, updateTruckFromSubscription, resetSubscriptionUpdateFlag, setSubscriptionTruckData } = getTruckReducerSlice.actions;

// Selectors
export const getTruckSelector = (state) => {   
    return state.getTruckReducer;
};

export default getTruckReducerSlice.reducer;
